import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { activityLog } from "@/features/activityLog";
import { subscribeAdminPreview } from "@/shared/config/admin";
import { useUser } from "@/shared/lib/hooks/useUser/useUser";
import { routePattern } from "../lib/routePattern";

export const ActivityLogRoot = () => {
    const location = useLocation();
    const { user } = useUser();

    useEffect(() => {
        activityLog.start({ routePattern });
    }, []);

    // UserProvider пишет user в localStorage своим эффектом, а он срабатывает
    // после эффектов детей — читаем личность на следующем тике.
    useEffect(() => {
        const t = setTimeout(() => activityLog.refreshIdentity("user_context"), 0);
        return () => clearTimeout(t);
    }, [user]);

    useEffect(() => {
        activityLog.pages.onRoute(location.pathname, location.search);
        // Просмотр страницы — это смена пути; смена одного ?q= — не переход.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    useEffect(
        () => subscribeAdminPreview((on) => activityLog.track("admin_preview_toggle", { on })),
        [],
    );

    return null;
};
